import { render, staticRenderFns } from "./ErrorPart.vue?vue&type=template&id=6c23f11e"
import script from "./ErrorPart.vue?vue&type=script&lang=ts"
export * from "./ErrorPart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports